const SFDRCategoryEnum = Object.freeze({
    ARTICLE_6: 'ARTICLE_6',
    ARTICLE_8: 'ARTICLE_8',
    ARTICLE_9: 'ARTICLE_9',
    NO_CATEGORY: 'NO_CATEGORY'
});

export default SFDRCategoryEnum;
